export default __webpack_public_path__ + "static/media/running_pilot.e71736ba.png";